/*
 *
 * EditorLists constants
 *
 */

export const PROCESSING = 'app/EditorLists/PROCESSING';
export const CREATE_LIST = 'app/EditorLists/CREATE_LIST';
export const CREATE_LIST_RESULT = 'app/EditorLists/CREATE_LIST_RESULT';
export const GET_LISTS = 'app/EditorLists/GET_LISTS';
export const GET_LISTS_RESULT = 'app/EditorLists/GET_LISTS_RESULT';
export const DELETE_LIST = 'app/EditorLists/DELETE_LIST';
export const DELETE_LIST_SUCCESS = 'app/EditorLists/DELETE_LIST_SUCCESS';
export const DELETE_LIST_FAIL = 'app/EditorLists/DELETE_LIST_FAIL';
export const RENAME_LIST = 'app/EditorLists/RENAME_LIST';
export const RENAME_LIST_SUCCESS = 'app/EditorLists/RENAME_LIST_SUCCESS';
export const RENAME_LIST_FAIL = 'app/EditorLists/RENAME_LIST_FAIL';
